
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { ActiveDirectoryConfig } from '../../system/types';

interface ConnectionStatusProps {
  adConfig: ActiveDirectoryConfig;
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ adConfig }) => {
  return (
    <Badge 
      variant={adConfig.status === 'connected' ? 'default' : 'destructive'}
      className="ml-2"
    >
      {adConfig.status === 'connected' ? 'Connected' : 'Disconnected'}
    </Badge>
  );
};

export default ConnectionStatus;
